import { render, staticRenderFns } from "./RecommendationEdit.vue?vue&type=template&id=8d583292&scoped=true"
import script from "./RecommendationEdit.vue?vue&type=script&lang=js"
export * from "./RecommendationEdit.vue?vue&type=script&lang=js"
import style0 from "./RecommendationEdit.vue?vue&type=style&index=0&id=8d583292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d583292",
  null
  
)

export default component.exports